import React, { useEffect, useState } from "react";
import { fetchData } from "../../utility/adminApi";
import { truncateWords } from "../../components/truncateWords";

function LowStockHome() {
  const [lowStock, setLowStock] = useState("");
  const fetchLowstock = async (page = 1, search = "") => {
    const response = await fetchData("products/low_stock", 1, "");
    setLowStock(response?.data ? response?.data : []);
  };

  useEffect(() => {
    fetchLowstock();
  }, []);
  return (
    <div className="flex flex-col gap-4">
      {lowStock.length > 0 ? (
        lowStock.map((item) => (
          <div
            key={item?.id}
            className="flex items-center gap-3 w-full rounded-lg border-2 p-2 justify-between shadow-lg"
          >
            <h4 className="text-wrap text-red-500">
              {truncateWords(item?.product_name, 20)}
            </h4>
            <h3>{item?.available_quantity}</h3>
          </div>
        ))
      ) : (
        <p className="text-gray-500">No low-stock items found.</p>
      )}
    </div>
  );
}

export default LowStockHome;
